<div class="h-screen flex relative lg:static bg-zinc-975 text-primary">
  <app-sidebar></app-sidebar>
  <!-- Inset content shell: rounded panel on the rail-colored page background,
       8px off the top/right/bottom edges, flush against the rail. -->
  <div class="min-w-0 flex-1 py-2 pr-2">
    <div class="flex h-full flex-col overflow-hidden rounded-2xl bg-zinc-960">
      <header>
        <app-topbar></app-topbar>
      </header>
      <div class="pt-3 px-6 pb-12 overflow-y-auto flex-1">
        <!-- Design content measure: 1152px inner width, centered -->
        <div class="mx-auto w-full max-w-6xl">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
